
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RequestQuote from "../components/RequestQuote";



import { FiPhone, FiClock, FiMapPin } from "react-icons/fi";

import "../assets/css/RequestForQuote.css";

const RequestForQuote = () => {

  return (
    <>
      <Navbar />

      <main id="request-demo-page">
        {/* HERO */}
        <section className="demo-hero">
          <div className="request-demo-container">
            <span className="section-tag">BOOK A DEMO</span>

            <h1>
              Partner with Us to Build Something
              <br />
              Exceptional
            </h1>

            <p>
              Tell us about your project, and our team will review your
              requirements and get back to you with the best next steps.
            </p>
          </div>
        </section>

        {/* CONTACT SECTION */}
        <section className="demo-contact">
          <div className="request-demo-container">
            <div className="demo-grid">
              {/* LEFT SIDE */}
              <div className="contact-info">
                <div className="info-card">
                  <div className="info-icon">
                    <FiPhone />
                  </div>

                  <h4>Get in Touch</h4>

                  <p>02013300308</p>
                  <p>info@outcess.com</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <FiClock />
                  </div>

                  <h4>Hours of Operation</h4>

                  <p>
                    Monday – Friday
                    <br />
                    9:00am – 6:00pm
                  </p>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <FiMapPin />
                  </div>

                  <h4>Our Locations</h4>

                  <p>
                    75 Opebi Road Ikeja,
                    <br />
                    Lagos State, Nigeria
                  </p>

                  <p>
                    Suite 125, 321 Ballenger Centre Drive,
                    <br />
                    Frederick, MD 21703, USA
                  </p>
                </div>
              </div>

              {/* RIGHT SIDE */}
        <div className="contact-form-wrapper">
             <RequestQuote />
        </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default RequestForQuote;